function VideoPlayIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width='54' height='54' viewBox='0 0 54 54' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
            <g opacity='0.76'>
                <rect width='54' height='54' rx='27' fill='white' />
                <path
                    d='M23.0175 35.9486C22.2557 35.9486 21.5325 35.7654 20.8961 35.3989C19.3918 34.5311 18.5625 32.7664 18.5625 30.4425V23.5671C18.5625 21.2336 19.3918 19.4786 20.8961 18.6107C22.4004 17.7429 24.3386 17.9068 26.3636 19.0736L32.3132 22.5064C34.3286 23.6732 35.4471 25.2739 35.4471 27.0096C35.4471 28.7454 34.3382 30.3461 32.3132 31.5129L26.3636 34.9457C25.1968 35.6111 24.0589 35.9486 23.0175 35.9486Z'
                    fill='#374151'
                />
            </g>
        </svg>
    );
}

export default VideoPlayIcon;

